/****************************************************
 * Module Name:  revise.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React from "react";
import Constants from "../../utility/constants";
import NoPermission from "../common/noPermission";
import {
    Box,
    Typography,
} from "@mui/material";
import { useMediaQuery } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import SwipeableViews from "react-swipeable-views";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import InsightsIcon from '@mui/icons-material/Insights';
import ReviseAverage from "./reviseAverage";
import ReviseStock from "./reviseStock";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Box
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ pt: 1 }}>
                    <Typography component={"span"}>{children}</Typography>
                </Box>
            )}
        </Box>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};


const Revise = () => {
    const theme = useTheme();
    const [value, setValue] = React.useState(
        Constants.USER_PERMISSION.find(
            (iPermission) =>
                iPermission.permissionid ===
                Constants.PERMISSIONS.OPERATION_REVISE_STOCK
        ) !== undefined
            ? 0
            : Constants.USER_PERMISSION.find(
                (iPermission) =>
                    iPermission.permissionid ===
                    Constants.PERMISSIONS.OPERATION_REVISE_AVERAGE
            ) !== undefined
                ? 1
                : 2
    );

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        setValue(index);
    };

    const matches = useMediaQuery("(min-width:1200px)");

    function a11yProps(index) {
        return {
            id: `full-width-tab-${index}`,
            "aria-controls": `full-width-tabpanel-${index}`,
            value: index,
        };
    }

    return (
        value === 2 ? <NoPermission /> :
            <Box
                sx={{ bgcolor: "background.paper", width: "100%", padding: "10px" }}
            >
                <AppBar position="static" sx={{ bgcolor: "#03a9f4", height: 50 }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="secondary"
                        textColor="inherit"
                        variant={matches ? "fullWidth" : "scrollable"}
                        scrollButtons="auto"
                        aria-label="full width tabs example"
                        sx={{
                            "& .css-1vw5i9y-MuiButtonBase-root-MuiTab-root": {
                                color: "#212121",
                                fontWeight: "bold",
                                textAlign: 'center'
                            },
                            "& .MuiTab-root": {
                                paddingBottom: 4
                            },
                            "& .Mui-selected": {
                                bgcolor: "#0277bd !important",
                                color: "#fafafa !important",
                                fontWeight: "bold !important",
                                paddingBottom: 4
                            }
                        }}
                        TabIndicatorProps={{ style: { background: "#0277bd" } }}
                    >
                        {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                                iPermission.permissionid ===
                                Constants.PERMISSIONS.OPERATION_REVISE_STOCK
                        ) !== undefined ? (
                            <Tab
                                icon={<CurrencyRupeeIcon size={22} />}
                                iconPosition="start"
                                label="Revise Stock"
                                {...a11yProps(0)}
                            />
                        ) : null}
                        {Constants.USER_PERMISSION.find(
                            (iPermission) =>
                                iPermission.permissionid ===
                                Constants.PERMISSIONS.OPERATION_REVISE_AVERAGE
                        ) !== undefined ? (
                            <Tab
                                icon={<InsightsIcon size={22} />}
                                iconPosition="start"
                                label="Revise Average"
                                {...a11yProps(1)}
                            />
                        ) : null}
                    </Tabs>
                </AppBar>
                <SwipeableViews
                    axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                    index={value}
                    onChangeIndex={handleChangeIndex}
                >
                    {Constants.USER_PERMISSION.find(
                        (iPermission) =>
                            iPermission.permissionid ===
                            Constants.PERMISSIONS.OPERATION_REVISE_STOCK
                    ) !== undefined ? (
                        <TabPanel value={value} index={0}>
                            <ReviseStock />
                        </TabPanel>
                    ) : null}
                    {Constants.USER_PERMISSION.find(
                        (iPermission) =>
                            iPermission.permissionid ===
                            Constants.PERMISSIONS.OPERATION_REVISE_AVERAGE
                    ) !== undefined ? (
                        <TabPanel value={value} index={1}>
                            <ReviseAverage />
                        </TabPanel>
                    ) : null}
                </SwipeableViews>
            </Box>
    );
}

export default Revise;